/*
 * pdp-photo-scroll.js — minimal, self-contained horizontal photo carousel for
 * the product media gallery. Dawn's native slider (slider-component) relies on
 * global.js, which is absent in this theme, so this adds click arrows + dot
 * indicators on top of the CSS scroll-snap track. No external dependencies.
 * Activates only when a gallery has more than one photo.
 */
(function () {
  function initGallery(root) {
    if (root.dataset.photoScrollInit) return;
    var list = root.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return; // nothing to scroll between
    root.dataset.photoScrollInit = '1';

    var track = list.parentElement; // <slider-component class="slider-mobile-gutter">

    function indexFromScroll() {
      return Math.round(list.scrollLeft / list.clientWidth);
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var target = i * list.clientWidth;
      if (Math.abs(target - list.scrollLeft) < 1) return;
      // scroll-snap: mandatory + the browser's smooth-scroll fight each other and
      // stall the jump. Disabling snap and setting scrollLeft directly is reliable;
      // we land exactly on a snap point, so snap can be restored immediately.
      list.style.scrollSnapType = 'none';
      list.scrollLeft = target;
      requestAnimationFrame(function () {
        list.style.scrollSnapType = '';
        update();
      });
    }

    // arrows
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pdp-photo-scroll__arrow pdp-photo-scroll__arrow--prev';
    prev.setAttribute('aria-label', 'Previous photo');
    prev.innerHTML = '‹';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'pdp-photo-scroll__arrow pdp-photo-scroll__arrow--next';
    next.setAttribute('aria-label', 'Next photo');
    next.innerHTML = '›';
    prev.addEventListener('click', function () { goTo(indexFromScroll() - 1); });
    next.addEventListener('click', function () { goTo(indexFromScroll() + 1); });
    track.appendChild(prev);
    track.appendChild(next);

    // dots
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'pdp-photo-scroll__dots';
    var dots = slides.map(function (slide, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'pdp-photo-scroll__dot' + (i === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Go to photo ' + (i + 1));
      d.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(d);
      return d;
    });
    if (track.parentNode) track.parentNode.insertBefore(dotsWrap, track.nextSibling);

    function update() {
      var i = indexFromScroll();
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      // dim (don't hide) the arrow at each end so the row never jumps
      prev.classList.toggle('pdp-photo-scroll__arrow--end', i <= 0);
      next.classList.toggle('pdp-photo-scroll__arrow--end', i >= slides.length - 1);
    }
    var raf;
    list.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    var galleries = document.querySelectorAll('media-gallery, [id^="MediaGallery-"]');
    Array.prototype.forEach.call(galleries, initGallery);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
